import { computed } from 'vue'

import { useUserStore } from '@stores/users'

import relevizeLogoWhite from '@/assets/logos/relevize-logo-white.png'

import { DEFAULT_HEX_COLOR } from '@components/constants/portals'

export function usePortalBranding() {
  const userStore = useUserStore()

  const logoHref = computed(() => {
    if(userStore.vendorId) {
      return userStore.vendor?.media_library_logo_href || relevizeLogoWhite
    }
    if(userStore.partnerId) {
      const partnerVendors = userStore.partner?.vendors
      if(partnerVendors && partnerVendors.length === 1) {
        return partnerVendors[0].media_library_logo_href || relevizeLogoWhite
      }
      return relevizeLogoWhite
    }
    return relevizeLogoWhite
  })

  const hexColor = computed(() => {
    if(userStore.vendorId) {
      return userStore.vendor?.hex_color || DEFAULT_HEX_COLOR
    }
    if(userStore.partnerId) {
      const partnerVendors = userStore.partner?.vendors
      if(partnerVendors && partnerVendors.length === 1) {
        return partnerVendors[0].hex_color || DEFAULT_HEX_COLOR
      }
      return DEFAULT_HEX_COLOR
    }
    return DEFAULT_HEX_COLOR
  })

  return {
    logoHref,
    hexColor,
  }
}